import PaperMascot from "./PaperMascot";
import { BOT_LOOKS } from "./mascotMood";

const NAMES = { kafi: "Kafi", kosi: "Kosi", kemi: "Kemi" };

// state: idle | thinking | won | lost
export default function BotMascot({ bot, state = "idle", size = 64, shadow = false, className }) {
  const key = String(bot || "").toLowerCase();
  const look = BOT_LOOKS[key];
  if (!look) return null;
  return (
    <PaperMascot
      face={look.faces[state] || look.faces.idle}
      color={look.color}
      accessory={look.accessory}
      size={size}
      shadow={shadow}
      label={NAMES[key]}
      className={className}
    />
  );
}
